import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
/**
 * Airbag around the in-call UI. A render crash inside the call panel (e.g. a
 * browser extension or page translator mutating DOM nodes behind React's
 * back → "insertBefore ... NotFoundError") previously took down the whole
 * React tree, which unmounted the call hook's consumers and dropped the user
 * out of a LIVE call. The call logic lives in the PARENT (hook), so catching
 * the crash here keeps the call connected; the user just re-opens the panel.
 */
const Fallback = ({ onRetry }) => {
    const { t } = useTranslation();
    return (_jsxs("div", { style: {
            padding: "8px 12px",
            background: "rgba(180,40,40,0.15)",
            border: "1px solid rgba(180,40,40,0.4)",
            borderRadius: 8,
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontSize: 13,
        }, children: [_jsx("span", { children: t("mobile.chat.call.panelCrashed", "Call panel hit a display error — the call is still connected.") }), _jsx("button", { onClick: onRetry, style: { padding: "4px 10px", borderRadius: 6, cursor: "pointer" }, children: t("mobile.chat.call.panelCrashedRetry", "Restore panel") })] }));
};
export class CallErrorBoundary extends React.Component {
    state = { crashed: false };
    static getDerivedStateFromError() {
        return { crashed: true };
    }
    componentDidCatch(error) {
        console.error("[voiceCall] call panel render crashed (call kept alive):", error);
    }
    render() {
        if (this.state.crashed) {
            return _jsx(Fallback, { onRetry: () => this.setState({ crashed: false }) });
        }
        return this.props.children;
    }
}
export default CallErrorBoundary;
